<template>
  <v-form v-disable-all="userCanEdit" ref="form" v-model="formPersonaValid" @submit.prevent="onSubmit($event)">
    <v-card tile outlined>
      <v-container>

        <v-card-text>
          <v-row>
            <v-col cols="4" sm="4" md="4">
              <v-text-field v-model="itemPersona.codigo" label="Nº persona" readonly>
              </v-text-field>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="6" sm="6" md="6">
              <v-text-field v-model="itemPersona.nombre" label="Apellidos y nombre*" required :rules="requireRule">
              </v-text-field>
            </v-col>

            <v-col cols="6" sm="6" md="6">
              <v-text-field v-model="itemPersona.dni" label="DNI">
              </v-text-field>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="6" sm="6" md="6">
              <date-picker v-model="itemPersona.fechaNacimiento" label="Fecha Nacimiento*" :rules="requireRule"
                :max="getEndDate"></date-picker>
            </v-col>

            <v-col cols="6" sm="6" md="6">
              <v-text-field v-model="itemPersona.email" label="Email">
              </v-text-field>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="6" sm="6" md="6">
              <v-text-field v-model="itemPersona.telefono" label="Teléfono">
              </v-text-field>
            </v-col>

            <v-col cols="6" sm="6" md="6">
              <v-text-field v-model="itemPersona.telefono2" label="Teléfono 2">
              </v-text-field>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="6" sm="6" md="6">
              <v-text-field v-model="itemPersona.direccion" label="Dirección">
              </v-text-field>
            </v-col>

            <v-col cols="6" sm="6" md="6">
              <v-text-field v-model="itemPersona.codigoPostal" label="Código Postal">
              </v-text-field>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="6" sm="6" md="6">
              <v-text-field v-model="itemPersona.poblacion" label="Población">
              </v-text-field>
            </v-col>

            <v-col cols="6" sm="6" md="6">
              <v-text-field v-model="itemPersona.provincia" label="Provincia">
              </v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6" sm="6" md="6">
              <v-switch v-model="itemPersona.disabled" color="primary" label="¿Eliminar usuario?"></v-switch>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12">
              <v-textarea class="" label="Observaciones" v-model="itemPersona.observaciones"></v-textarea>
            </v-col>
          </v-row>

          <small>*Indica campo requerido</small>
        </v-card-text>

        <v-card-actions v-if="userCanEdit">
          <v-btn type="submit" color="primary" :loading="loading" text :disabled="!formPersonaValid">
            Guardar
          </v-btn>
        </v-card-actions>

      </v-container>
    </v-card>
  </v-form>
</template>

<script>

import { putPersona } from '@/api/personas.api'
import DateUtils from '@/libraries/DateUtils'
import DatePicker from '@/components/DatePicker'

export default {
  name: 'PersonaForm',
  props: {
    item: {
      type: Object,
      required: true,
    },

    userCanEdit: {
      type: Boolean,
      required: true
    }

  },

  components: {
    DatePicker
  },

  data: () => {
    return {
      itemPersona: null,
      formPersonaValid: false,
      loading: false,
      requireRule: [
        v => !!v || 'El campo es obligatorio',
      ],
    }
  },

  created() {
    // asignar prematricula
    this.itemPersona = Object.assign(this.item)

    //fechas datepick  
    let dateUtils = new DateUtils(this.itemPersona.fechaNacimiento)
    this.itemPersona.fechaNacimiento = dateUtils.formatDateYYYYMMDD()
  },

  computed: {
    getEndDate() {
      let dateUtils = new DateUtils()
      return dateUtils.formatDateYYYYMMDD()
    }
  },

  methods: {

    async onSubmit(event) {
      this.loading = true;

      // validacion y emit
      if (this.formPersonaValid) {

        let params = {
          fechaNacimiento: this.itemPersona.fechaNacimiento,
          nombre: this.itemPersona.nombre,
          dni: this.itemPersona.dni,
          email: this.itemPersona.email,
          telefono: this.itemPersona.telefono,
          telefono2: this.itemPersona.telefono2,
          direccion: this.itemPersona.direccion,
          codigoPostal: this.itemPersona.codigoPostal,
          poblacion: this.itemPersona.poblacion,
          provincia: this.itemPersona.provincia,
          observaciones: this.itemPersona.observaciones,
          disabled: this.itemPersona.disabled
        }

        // actualizar datos de la persona
        await putPersona(this.item.id, params).then(response => {
          this.$emit('submitPersona', event, response)
        }).catch(error => {
          console.error(error)
        })

      }
      this.loading = false
    }

  }

}

</script>